<template>
    <div class="bg-red-500 text-white rounded p-4 block mb-4" v-if="errors" id="crud-error-container">
        <heading size="small" colour="white">Please check the following.</heading>
        <ul class="list-none">
            <li v-for="(errors,field) in errors"><i class="fas fa-angle-right"></i> {{ errors.join('. ') }}</li>
        </ul>
        <div class="md:flex md:flex-row-reverse mt-2">
          <ui-button size="small" colour="white" @click.prevent="dismissErrors()">Dismiss</ui-button>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['errors'],
        watch:{
            errors: function(errs){
                if( errs )
                {
                    window.setTimeout(function(){
                        window.location.hash = '#crud-error-container';
                    },200);
                }
            }
        },
        methods: {
            dismissErrors() {
                window.eventBus.$emit('crud-errors-dismissed');
            }
        }
    }
</script>
